import ReduxActions from '../../constants/redux-actions';
import { ErrorCodes } from '../../models/error-code';
import { BaseAction } from '../model/action';

const defaultState = {
  isAuthenticated: undefined,
  error: ErrorCodes.none,
  loginUrl: null,
  hubConnection: null,
  logoutError: ErrorCodes.none,
};

const authenticate = (state = defaultState, action: BaseAction) => {
  switch (action.type) {
    case ReduxActions.AUTHENTICATE:
      return {
        ...state,
        error: action.data.error,
        isAuthenticated: action.data.isAuthenticated,
      };
    case ReduxActions.SET_IS_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.data,
        // A successful login ends whatever error the previous attempt left behind, so it does not reappear later.
        error: action.data === true ? ErrorCodes.none : state.error,
      };
    case ReduxActions.SET_AUTH_URL:
      return {
        ...state,
        loginUrl: action.data,
      };
    case ReduxActions.SET_HUB_CONNECTION:
      return {
        ...state,
        hubConnection: action.data,
      };
    case ReduxActions.SET_LOGOUT_ERROR:
      return {
        ...state,
        logoutError: action.data,
      };
    default:
      return state;
  }
};

export default authenticate;
